import { AppException } from './AppException';

export class ComponentException extends AppException {
  public readonly name: string;
  public readonly methodName: string;
  public readonly props: Record<string, unknown>;
  constructor(
    name: string,
    methodName: string,
    props: Record<string, unknown>,
    err: Error,
    data: unknown,
    sendToSentry = true,
  ) {
    super(err, data, sendToSentry);
    this.name = name;
    this.methodName = methodName;
    this.props = props;
  }

  override get extras(): any {
    return {
      type: 'Component',
      methodName: this.methodName,
      component: this.name,
      props: this.props,
    };
  }

  static from(
    name: string,
    methodName: string,
    props: Record<string, unknown>,
    err: unknown,
    data: unknown,
    sendToSentry = true,
  ): ComponentException {
    return new ComponentException(name, methodName, props, err as Error, data, sendToSentry);
  }
}
